import {StyledGrid} from 'presentation/components';
import {PlanCard} from 'presentation/pages/others/selection-flow/components';
import React from 'react';

import {RenderPlansProps} from './types';

export const RenderPlans = ({plans, planCardSelectedState, handleSelectPlan}: RenderPlansProps) =>
	plans.map(plan => {
		const planUniqueId = `${plan?.nuContrato}-${plan?.tipoBeneficiarioLogado}`;

		return (
			<StyledGrid.Item sm={12} md={12} lg={6} xl={4} key={planUniqueId}>
				<PlanCard
					selected={planCardSelectedState === planUniqueId}
					onSelect={handleSelectPlan}
					plan={plan}
				/>
			</StyledGrid.Item>
		);
	});
